// Trending Movies types based on backend API

// Enum cho các loại trending
export enum TrendingType {
  TRENDING = 'trending',
  BANNER = 'banner',
}

export interface TrendingMovies {
  _id: string;
  type: TrendingType;
  movies: string[];
  position: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TrendingMoviesWithDetails extends Omit<TrendingMovies, 'movies'> {
  movies: ArticleDetails[];
}

export interface ArticleDetails {
  _id: string;
  title: string;
  slug: string;
  featuredImage?: {
    url: string;
    alt?: string;
    title?: string;
  };
  image?: {
    url: string;
    alt?: string;
    title?: string;
  };
  category?: Array<{
    _id: string;
    name: string;
    url: string;
  }>;
  viewCount?: number;
  film_description?: string;
  createdAt: string;
}

export interface UpdateTrendingMoviesDto {
  type: TrendingType;
  movies: string[];
  position?: number;
  isActive?: boolean;
}

export interface TrendingMoviesApiResponse {
  data: TrendingMoviesWithDetails;
  message: string;
}
